export const apiConfigs = {
    FETCH_CAMPAIGNS: {
        method: "GET",
        url: '/campaign',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch all campaigns",
    },
    FETCH_INVITED_CAMPAIGNS: {
        method: "GET",
        url: '/i/campaign/invited',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch invited campaigns",
    },
    FETCH_CAMPAIGN: {
        method: "GET",
        url: '/campaign/<campaignId>',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch campaign by id",
    },
    FETCH_CAMPAIGN_APPLICATION: {
        method: "GET",
        url: '/i/application/<campaignId>',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch campaign application by campaign id",
    },
    APPLY_CAMPAIGN: {
        method: "POST",
        url: '/i/application/<campaignId>',
        description: "Apply on a campaign by campaign id"
    },
    FETCH_CAMPAIGN_PUBLIC: {
        method: "GET",
        url: '/c/<campaignId>',
        description: "Fetch campaign by id for public page without auth",
    },

    FETCH_COLLABORATIONS: {
        method: "GET",
        url: 'i/collaboration',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch all collaborations",
    },
    FETCH_COLLABORATION: {
        method: "GET",
        url: 'i/collaboration/<campaignId>',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch collaboration data",
    },

    FETCH_WALLET: {
        method:"GET",
        url: '/i/wallet',
        staleTime: 10*60*1000 //10 minutes
    },

    FETCH_REFERRALS: {
        method:"GET",
        url: '/i/referral',
        staleTime: 10*60*1000 //10 minutes
    },

    FETCH_MEMBERSHIP: {
        method: "GET",
        url: "i/membership",
        staleTime: 10*60*1000 // 10 minutes
    },

    FETCH_PRICING: {
        method: "GET",
        url: "i/pricing",
        staleTime: 10*60*1000 // 10 minutes
    },

    FETCH_INFLUENCER_INSIGHTS: {
        method: "GET",
        url: "i/insights",
        staleTime: 10*60*1000 // 10 minutes
    },
    FETCH_INFLUENCER_CONTENT: {
        method: 'GET',
        url: 'i/post',
        staleTime: 10*60*1000, // 10 minutes
        description: 'Fetch influencer media content'
    },
    FETCH_INFLUENCER_POST: {
        method: 'GET',
        url: 'i/post/<postId>',
        staleTime: 10*60*1000, // 1 minutes
        description: 'Fetch influencer media content'
    },

    GET_IG_AUTH_URL: {
        method: "GET",
        url: "i/c/ig"
    },

    FETCH_DM_AUTOMATIONS: {
        method: "GET",
        url: 'i/dm-automation',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch all automations",
    },

    FETCH_DM_AUTOMATION: {
        method: "GET",
        url: 'i/dm-automation/<postId>',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch all post's dm automation",
    },

    CREATE_DM_AUTOMATION: {
        method: "POST",
        url: 'i/dm-automation',
        description: "Create new post dm automation",
    },

    UPDATE_DM_AUTOMATION: {
        method: "PUT",
        url: 'i/dm-automation/<postId>',
        description: "Update post dm automation",
    },
    
    DELETE_DM_AUTOMATION: {
        method: "DELETE",
        url: 'i/dm-automation/<postId>',
        description: "Delete post dm automation",
    },
    FETCH_MAP_PLACES: {
        method: 'POST',
        url: '/i/place/search'
    },
    FETCH_PLACE: {
        method: 'GET',
        url: '/i/place/<placeId>'
    },
    STORE_ADDRESS: {
        method: 'POST',
        url: 'i/address'
    },
    FETCH_ADDRESSES: {
        method: 'GET',
        url: '/i/address',
        staleTime: 10*60*1000   
    },
    FETCH_ADDRESS: {
        method: 'GET',
        url: '/i/address/<addressId>',
        staleTime: 10*60*1000
    },
    FETCH_COLLABORATION_PERMALINK_FILE: {
        method: "POST",
        url: "i/collaboration/<campaignId>/permalink-file",
        staleTime: 10*60*1000
    },
    FETCH_COLLABORATION_MILESTONE: {
        method: 'GET',
        url: "i/collaboration/<campaignId>/milestone/<milestoneId>",
        staleTime: 10*60*1000
    },
    SUBMIT_COLLABORATION_MILESTONE_STEP: {
        method: "POST", 
        url: 'i/collaboration/<campaignId>/step'
    },
    ACKNOWLEDGE_MILESTONE : {
        method: "POST",
        url: '/i/collaboration/<campaignId>/milestone/<milestoneId>/acknowledge'
    },
    SUBMIT_STEP_DEADLINE: {
        method: "POST",
        url: "/i/collaboration/<campaignId>/step/<stepSlug>/deadline"
    },
    GET_SIGNED_GCS_URL: {
        url: '/i/collaboration/<campaignId>/upload/url',
        method: "POST"
    },
    LINK_UPLOADED_GCS_FILE_WITH_MILESTONE_STEP: {
        url: '/i/collaboration/<campaignId>/upload/link',
        method: 'POST'
    },
    FETCH_CONVERSION_CAMPAIGNS: {
        method: "GET",
        url: '/i/conversion_campaign',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch all conversion campaigns",
    },
    FETCH_CONVERSION_CAMPAIGN: {
        method: "GET",
        url: '/i/conversion_campaign/<campaignId>',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch conversion campaign by id",
    },
    FETCH_CONVERSION_CAMPAIGN_PUBLIC: {
        method: "GET",
        url: '/cc/<campaignId>',
        description: "Fetch campaign by id for public page without auth",
    },
    FETCH_CONVERSION_CAMPAIGN_LINKS: {
        method: "GET",
        url: '/i/conversion_campaign/<campaignId>/link',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch conversion campaign links by id",
    },
    ADD_CONVERSION_CAMPAIGN_LINK: {
        method: "POST",
        url: '/i/conversion_campaign/<campaignId>/link',
    },
    FETCH_CONVERSION_CAMPAIGN_COMMISSION: {
        method: "GET",
        url: '/i/conversion_campaign/commission',
        staleTime: 10*60*1000, // 10 minutes
        description: "Fetch conversion campaign commissions",
    },
    FETCH_CONVERSION_CAMPAIGN_LINK: {
        method: "GET",
        url: '/i/conversion_campaign/<campaignId>/link/<linkId>',
        staleTime: 10*60*1000, // 10 minutes
    },
    SUBMIT_IG_HANDLE: {
        method: "POST",
        url: '/i/c/ig/handle'
    },
    FETCH_IG_HANDLE_VERIFICATION_STATUS: {
        method: "POST",
        url: '/i/c/ig/handle/verify'
    },
    FETCH_POST_BASIC: {
        method: 'GET',
        url: '/i/post/<postId>/basic',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_POST_BASIC: {
        method: 'GET',
        url: '/i/social-post/<postId>',
        staleTime: 10*60*1000
    },
    FETCH_COLLABORATIONS_TASKS: {
        method: 'GET',
        url: '/i/collaboration/task',
        staleTime: 10*60*1000
    },
    FETCH_COLLABORATION_TASKS_SUMMARY: {
        method: 'GET',
        url: '/i/collaboration/task/summary',
        staleTime: 10*60*1000
    },
    FETCH_PAN_DETAILS : {
        method: 'GET',
        url: '/i/pan',
        staleTime: 10*60*1000
    },
    VALIDATE_PAN: {
        method: 'POST',
        url: '/i/pan/validate'
    },
    STORE_PAN: {
        method: 'POST',
        url: '/i/pan'
    },
    DEVICE_REGISTRATION: {
        url: '/user/device/register',
        method: 'POST'
    },
    DEVICE_VERSION_CHECK: {
        url: '/device/version/check',
        method: 'GET'
    },
    CREATE_FIREBASE_TOKEN: {
        url: '/i/firebase-token',
        method: 'POST',
        staleTime: 50*60*1000
    },
    COLLAB_CHAT_ROOM: {
        url: '/i/collaboration/<campaignId>/chat-room',
        method: 'POST'
    },
    AVAILABLE_POSTS_DM_AUTOMATION: {
        url: '/i/dm-automation/available',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_POST :{
        url: '/i/social-account/<socialAccountId>/post/<socialPostId>',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_POSTS: {
        url: '/i/social-account/<socialAccountId>/post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    UPDATE_INFLUENCER_LOCATION: {
        url: '/i/me/location',
        method: 'POST'
    },
    ADD_SOCIAL_ACCOUNT: {
        url: '/i/social-account',
        method: 'POST'
    },
    UPDATE_CHARGE_PER_REEL: {
        url: '/i/social-account/<socialAccountId>/charge-per-reel',
        method: 'POST'
    },
    FETCH_PLACE_LOCAL: {
        method: 'GET',
        url: '/i/address/create'
    },
    FETCH_ACCOUNT_DELETION_REQUESTS: {
        method: "GET",
        url: '/i/deletion-request',
        staleTime: 10*60*1000 //10 minutes
    },
    REQUEST_ACCOUNT_DELETION: {
        method: "POST",
        url: '/i/deletion-request'
    },
    CONVERSION_CAMPAIGN_GROUPED_EARNINGS: {
        method: "GET",
        url: '/i/conversion_campaign/commission/grouped',
        staleTime: 10*60*1000, // 10 minutes
    },
    FETCH_TICKER_FEED: {
        method: "GET",
        url: '/i/ticker',
        staleTime: 60*60*1000, // 1 hour
    },
    OPTIN_CONVERSION_CAMPAIGN: {
        method: "POST",
        url: '/i/conversion_campaign/<campaignId>/optin',
    },
    FETCH_URL_METADATA: {
        method: "POST",
        url: '/i/url/md',
    }
}